import * as React from "react";
import { useEffect, useState } from "react";
import { useStore } from "stores/connect";
import { ConfigurationsActions, ConfigurationsStore } from "stores/configurations/ConfigurationsStore";
import { getConfig } from "components/configurations/helpers";
import { ConfigurationType } from "components/configurations/ConfigurationTypes";
import { Button, Table } from "components/bootstrap";
import { IfPermitted } from "components/common";
import Spinner from "components/common/Spinner";
import BootstrapModalForm from "components/bootstrap/BootstrapModalForm";
import UrlAllowListForm from "components/configurations/UrlAllowListForm";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import useLocation from "routing/useLocation";
import { getPathnameWithoutId } from "util/URLUtils";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import useProductName from "brand-customization/useProductName";
const UrlAllowListConfig = () => {
  const productName = useProductName();
  const [showConfigModal, setShowConfigModal] = useState(false);
  const configuration = useStore(ConfigurationsStore, (state) => state == null ? void 0 : state.configuration);
  const [viewConfig, setViewConfig] = useState(void 0);
  const [formConfig, setFormConfig] = useState(void 0);
  const [isValid, setIsValid] = useState(false);
  const sendTelemetry = useSendTelemetry();
  const { pathname } = useLocation();
  useEffect(() => {
    ConfigurationsActions.list(ConfigurationType.URL_ALLOWLIST_CONFIG).then(() => {
      const config = getConfig(ConfigurationType.URL_ALLOWLIST_CONFIG, configuration);
      setViewConfig(config);
      setFormConfig(config);
    });
  }, [configuration]);
  const summary = () => {
    const literal = "literal";
    const { entries: entries2 } = viewConfig;
    return entries2.map((urlConfig, idx) => /* @__PURE__ */ React.createElement("tr", { key: urlConfig.id }, /* @__PURE__ */ React.createElement("td", null, idx + 1), /* @__PURE__ */ React.createElement("td", null, urlConfig.title), /* @__PURE__ */ React.createElement("td", null, urlConfig.value), /* @__PURE__ */ React.createElement("td", null, urlConfig.type === literal ? "Exact match" : "Regex")));
  };
  const openModal = () => {
    setShowConfigModal(true);
  };
  const closeModal = () => {
    setShowConfigModal(false);
    setFormConfig(viewConfig);
  };
  const saveConfig = () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.CONFIGURATIONS.URL_ALLOW_LIST_UPDATED, {
      app_pathname: getPathnameWithoutId(pathname),
      app_section: "urlallowlist",
      app_action_value: "configuration-save"
    });
    ConfigurationsActions.updateAllowlist(ConfigurationType.URL_ALLOWLIST_CONFIG, formConfig).then(() => {
      closeModal();
    });
  };
  const update = (newConfig, newIsValid) => {
    setFormConfig(newConfig);
    setIsValid(newIsValid);
  };
  if (!viewConfig || !formConfig) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  const { entries, disabled } = formConfig;
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h2", null, "URL Allowlist Configuration ", disabled ? /* @__PURE__ */ React.createElement("small", null, "(Disabled)") : /* @__PURE__ */ React.createElement("small", null, "(Enabled)")), /* @__PURE__ */ React.createElement("p", null, "When enabled, outgoing HTTP requests from ", productName, " servers, such as event notifications or HTTP-based data adapter requests, are validated against the allowlists configured here. Because the HTTP requests are made from the ", productName, " servers, they might be able to reach more sensitive systems than an external user would have access to, including AWS EC2 metadata, which can contain keys and other secrets, Elasticsearch and others. Allowlist administrative access is separate from data adapters and event notification configuration."), /* @__PURE__ */ React.createElement(Table, { bordered: true, condensed: true, className: "top-margin" }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "#"), /* @__PURE__ */ React.createElement("th", null, "Title"), /* @__PURE__ */ React.createElement("th", null, "URL"), /* @__PURE__ */ React.createElement("th", null, "Type"))), /* @__PURE__ */ React.createElement("tbody", null, summary())), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "urlallowlist:write" }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "info", bsSize: "xs", onClick: openModal }, "Edit configuration")), showConfigModal && /* @__PURE__ */ React.createElement(
    BootstrapModalForm,
    {
      show: true,
      bsSize: "lg",
      title: "Update Allowlist Configuration",
      onSubmitForm: saveConfig,
      onCancel: closeModal,
      submitButtonDisabled: !isValid,
      submitButtonText: "Update configuration"
    },
    /* @__PURE__ */ React.createElement("h3", null, "Allowlist URLs"),
    /* @__PURE__ */ React.createElement(UrlAllowListForm, { urls: entries, disabled, onUpdate: update })
  ));
};
export default UrlAllowListConfig;
